import React, { FC } from 'react'
import { CircularProgress } from '@mui/material'
import { ReactComponent as Logo } from '../../../assets/images/logo.svg'
import './loader.scss'

interface LoaderProps {
    transparent?: boolean
    _class?: string
}

const Loader: FC<LoaderProps> = ({ transparent = false, _class = '' }) => {
    return (
        <div className={`loader ${transparent && 'transparent'} ${_class}`}>
            <div className="loader-container">
                <CircularProgress size={92} thickness={2} />
                <Logo className="logo black-fill" />
            </div>
        </div>
    )
}

export default Loader
